var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXWithCircle = function SvgXWithCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#EA1C00",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.333 3.833a6.667 6.667 0 1 0 0 13.333 6.667 6.667 0 0 0 0-13.333M2 10.5a8.333 8.333 0 1 1 16.667 0A8.333 8.333 0 0 1 2 10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.833 6.821 2.5 2.5 2.5-2.5L14.01 8l-2.5 2.5 2.5 2.5-1.178 1.178-2.5-2.5-2.5 2.5L6.654 13l2.5-2.5-2.5-2.5z"
  }))));
};
export { SvgXWithCircle as Icon };
export default __webpack_public_path__ + "static/media/50f112a92fa94e51c23352112f0c9488.svg";